import Vue from "vue";
import App from "./App.vue";

import "@aws-amplify/ui-vue";
import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";

import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

import { AuthModeStrategyType, Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";

import router from "./router";
import store from "vuex";
import "./registerServiceWorker";

Amplify.configure({
  ...awsconfig,
  // aws_appsync_authenticationType: "AWS_IAM",
  DataStore: {
    authModeStrategyType: AuthModeStrategyType.MULTI_AUTH,
    // region: "eu-west-2",
  },
  // Storage: {
  //   AWSS3: {
  //     bucket: '', //REQUIRED -  Amazon S3 bucket name
  //     region: '', //OPTIONAL -  Amazon service region
  //   }
  // }
});

applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
